import { useNavigate } from "react-router-dom";
import { getRouteMap } from "./routeMaps";



export const useTabRoutes = (backRoute, id, currentTabId, isEdit) => {
  const routeMap = getRouteMap();
  const navigate = useNavigate();

  const mode = isEdit ? backRoute : "create";
  const tabIds = Object.keys(routeMap[mode] || {}).filter((key) => key !== "default");
  const currentTabIndex = tabIds.indexOf(currentTabId);

  const navigateToTab = (direction) => {
    const newIndex = currentTabIndex + direction;

    if (newIndex >= 0 && newIndex < tabIds.length) {
      const targetTabId = tabIds[newIndex];
      const routeFn = routeMap[mode][targetTabId];
      if (routeFn) {
        navigate(routeFn({ id }));
      }
    }
  };

  const navigateToNextTab = () => navigateToTab(1);
  const navigateToPreviousTab = () => navigateToTab(-1);

  return { navigateToNextTab, navigateToPreviousTab };
};
